import { render, staticRenderFns } from "./EventCalendar.vue?vue&type=template&id=364b2ddc&scoped=true"
import script from "./EventCalendar.vue?vue&type=script&lang=ts"
export * from "./EventCalendar.vue?vue&type=script&lang=ts"
import style0 from "./EventCalendar.vue?vue&type=style&index=0&id=364b2ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364b2ddc",
  null
  
)

export default component.exports